import { useTranslation } from 'react-i18next'
import Bredcrumb from '../../HomeMain/Bredcrumb'
import Pricing from '../../HomeMain/Pricing'

const Main = () => {
  const { t } = useTranslation()
  return (
    <>
      <Bredcrumb title={t('pages.pricing.title')} subtitle={t('pages.pricing.subtitle')} />
      <div className="pricing-block">
        <Pricing />
      </div>
    </>
  )
}

export default Main
